import { FC, HTMLAttributes } from 'react';
import { pageClasses } from '../page.constants';
import { Text } from '@/src/ui-components';
import { cn } from '@/src/helpers';

export type PageTitleProps = HTMLAttributes<HTMLHeadingElement>;

export const PageTitle: FC<PageTitleProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Text
      className={cn(
        pageClasses.title,
        className,
        'word-break-word flex items-center gap-2'
      )}
      {...rest}
      size="4xl"
      as="h1"
    >
      {children}
    </Text>
  );
};
